import React, { Component } from 'react'
import { connect } from 'react-redux'

import { reportType } from 'selectors/reports'

import MonthlyStatement from './MonthlyStatement'
import Report1099 from './Report1099'

let select = state => ({
	report: reportType(state)
})

export class Report extends Component{
	render(){
		let { props } = this
		return(
			<div>
				{props.report == "1099" && <Report1099 /> || props.report == "Monthly Statement" && <MonthlyStatement />}
			</div>
		)
	}
}

export default connect(select)(Report)



// WEBPACK FOOTER //
// ./src/routes/landlord/finances/Report/index.js